export default __webpack_public_path__ + "static/media/general-error-waves-first.27cec66c.png";